/**
 * Tracks which of several overlapping async requests is the latest, so a slow response for
 * an earlier selection can be ignored instead of overwriting the current one.
 *
 * Create one guard per component instance (never at module level, where it would be shared
 * across concurrent SSR requests).
 */
export const createStaleResponseGuard = () => {
  let latestRequestId = 0;

  return {
    /** Start a new request and return its id; any earlier request becomes stale. */
    start: () => ++latestRequestId,
    /** Whether the given request is still the latest one. */
    isCurrent: (requestId: number) => requestId === latestRequestId,
    /** Make any in-flight request stale without starting a new one. */
    invalidate: () => {
      latestRequestId++;
    },
  };
};
